module.exports = "/images/logo_beecrm_light_color.png?84aa1692e5b9725726d8ef00f5af9717";